package net.sergeych.kilogin

import net.sergeych.bintools.ByteChunk
import net.sergeych.crypto2.KDF
import net.sergeych.crypto2.SymmetricKey


/**
 * Super creds are derived from a password and given derivation parameters.
 * They should not be being sent over the network or stored (re-derivation is
 * usually required), so it is not serializable.
 * @param loginId cryptographically independent and strong id that depends on the password
 *                but does not disclose [loginAccessKey], Superlogin uses it to allow
 *                API access to ACO with login private key (it can be safely stored in the
 *                database)
 * @param loginAccessKey first symmetric key, used to decrypt ACO
 * @param extraKey just for future extensions. not used as for now.
 */
class DerivedKeys(
    val loginId: ByteChunk,
    val loginAccessKey: SymmetricKey,
    val pbkdParams: KDF,
    @Suppress("unused") val extraKey: SymmetricKey,
) {

    companion object {
        fun derive(password: String, kdf: KDF): DerivedKeys {
            val kk = kdf.deriveMultipleKeys(password, 3)
            return DerivedKeys(ByteChunk(kk[0].keyBytes), kk[1],
                kk[1].id.kdp!!.kdf,
                kk[2])
        }

        fun derive(password: String,complexity: KDF.Complexity) = derive(password, complexity.kdfForSize(3))
    }
}